import { AppLayout } from '@/components/layouts/AppLayout'
import { InvoicesTable } from '@/components/organisms/InvoicesTable'

const Invoices = () => {
  return (
    <AppLayout>
      <div className="space-y-6">
        <InvoicesTable />
      </div>
    </AppLayout>
  )
}

export default Invoices
